webpackJsonp([182246549230831],{

/***/ 223:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	// these sizes are arbitrary and you can set them to whatever you wish
	var defaulttheme = {
	  // Header landing section
	  headerTextColor: 'white',
	
	  // Button constants
	  buttonTextColor: 'white',
	  buttonBorderRadius: '4px',
	  filledButtonBGColor: '#19c7ff',
	  transparentButtonBGColor: 'rgba(255, 255, 255, 0.1)',
	  transparentButtonBorder: 'solid 1px rgba(255, 255, 255, 0.4);',
	
	  // darkBGColor: 'linear-gradient(#119ef7,#112e7e)',
	  navbar: {
	    lightBGColor: '#fffff',
	    darkBGColor: '#ffffff',
	    navTextColor: '#0a3981',
	    transparentNavTextColor: '#0a3981',
	    bgColor: '#fff',
	    transparentBGColor: 'transparent'
	  },
	  reachingWorldWide: {
	    headingColor: '#43484d',
	    subHeadingColor: '#5e6977',
	    descriptionColor: '#86939e',
	    applyColor: '#358ed7'
	  },
	  footerSection: {
	    background: '#122445',
	    inputBackground: 'rgba(255, 255, 255, 0.1)',
	    inputText: '#ffffff',
	    lightTextColor: '#ffffff',
	    filledButtonBGColor: '#19c7ff',
	    pageLinksColor: '#ffffff',
	    poweredByTextColor: '#43484d',
	    poweredbyBackgroundColor: '#ffffff',
	    poweredbyDivider: 'none',
	    white: '#ffffff'
	  }
	};
	exports.default = defaulttheme;
	module.exports = exports['default'];

/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * 
	                                                                                                                                                                                                                                                                   * @author: Vamsi Tallam
	                                                                                                                                                                                                                                                                   */
	
	/* eslint-disable no-undef, react/prop-types, react/no-danger */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(20);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _emotionTheming = __webpack_require__(59);
	
	var _ResponsiveContainer = __webpack_require__(15);
	
	var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);
	
	var _Header = __webpack_require__(24);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(25);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _whiteTheme = __webpack_require__(223);
	
	var _whiteTheme2 = _interopRequireDefault(_whiteTheme);
	
	var _darkTheme = __webpack_require__(30);
	
	var _darkTheme2 = _interopRequireDefault(_darkTheme);
	
	var _themeConstants = __webpack_require__(80);
	
	var _DateUtils = __webpack_require__(176);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _styledComponents = __webpack_require__(463);
	
	__webpack_require__(633);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Template = function Template(_ref) {
	  var data = _ref.data,
	      headerPropsData = _ref.headerPropsData,
	      footerProps = _ref.footerProps,
	      isBookNowSlotOpened = _ref.isBookNowSlotOpened,
	      bookNowModalData = _ref.bookNowModalData;
	
	  if (data) {
	    var blogPageData = data.blogPageData.edges;
	    var _blogPageData$0$node$ = blogPageData[0].node.frontmatter,
	        blogTemplateSEOData = _blogPageData$0$node$.blogTemplateSEOData,
	        date = _blogPageData$0$node$.date,
	        readingTime = _blogPageData$0$node$.readingTime,
	        heading = _blogPageData$0$node$.heading,
	        caption = _blogPageData$0$node$.caption,
	        authorPicUrl = _blogPageData$0$node$.authorPicUrl,
	        authorName = _blogPageData$0$node$.authorName,
	        authorDesignation = _blogPageData$0$node$.authorDesignation,
	        html = _blogPageData$0$node$.html,
	        disclaimer = _blogPageData$0$node$.disclaimer;
	    var metaTitle = blogTemplateSEOData.metaTitle,
	        metaDescription = blogTemplateSEOData.metaDescription,
	        ogTitle = blogTemplateSEOData.ogTitle,
	        ogUrl = blogTemplateSEOData.ogUrl,
	        ogImage = blogTemplateSEOData.ogImage,
	        ogDescription = blogTemplateSEOData.ogDescription,
	        ogType = blogTemplateSEOData.ogType,
	        ogSiteName = blogTemplateSEOData.ogSiteName,
	        twitterTitle = blogTemplateSEOData.twitterTitle,
	        twitterUrl = blogTemplateSEOData.twitterUrl,
	        twitterSite = blogTemplateSEOData.twitterSite,
	        twitterDescription = blogTemplateSEOData.twitterDescription,
	        twitterImage = blogTemplateSEOData.twitterImage,
	        canonicalUrl = blogTemplateSEOData.canonicalUrl,
	        schemaData = blogTemplateSEOData.schemaData;
	
	    var articleFormattedDate = (0, _DateUtils.getArticleFormattedDateTime)(date);
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _emotionTheming.ThemeProvider,
	        { theme: _whiteTheme2.default },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _styledComponents.BlogPageContainer,
	            { className: 'blogImageContainer' },
	            _react2.default.createElement(
	              _reactHelmet2.default,
	              { encodeSpecialCharacters: false },
	              _react2.default.createElement('link', {
	                href: 'https://fonts.googleapis.com/css?family=PT+Serif:400,400i,700,700i&display=swap',
	                rel: 'stylesheet'
	              }),
	              _react2.default.createElement(
	                'title',
	                null,
	                metaTitle
	              ),
	              _react2.default.createElement('link', { rel: 'canonical', href: canonicalUrl }),
	              _react2.default.createElement('meta', { name: 'description', content: metaDescription }),
	              _react2.default.createElement('meta', { property: 'og:title', content: ogTitle }),
	              _react2.default.createElement('meta', { property: 'og:url', content: ogUrl }),
	              _react2.default.createElement('meta', { property: 'og:image', content: ogImage }),
	              _react2.default.createElement('meta', { property: 'og:description', content: ogDescription }),
	              _react2.default.createElement('meta', { property: 'og:type', content: ogType }),
	              _react2.default.createElement('meta', { property: 'og:site_name', content: ogSiteName }),
	              _react2.default.createElement('meta', { property: 'twitter:title', content: twitterTitle }),
	              _react2.default.createElement('meta', { name: 'twitter:url', content: twitterUrl }),
	              _react2.default.createElement('meta', { name: 'twitter:site', content: twitterSite }),
	              _react2.default.createElement('meta', {
	                property: 'twitter:description',
	                content: twitterDescription
	              }),
	              _react2.default.createElement('meta', { name: 'twitter:image', content: twitterImage }),
	              _react2.default.createElement(
	                'script',
	                { type: 'application/ld+json' },
	                '' + schemaData
	              )
	            ),
	            _react2.default.createElement(_Header2.default, {
	              defaultBackground: _Colors2.default.darkGreyThree,
	              isWhite: true,
	              headerPropsData: headerPropsData,
	              isBookNowSlotOpened: isBookNowSlotOpened,
	              bookNowModalData: bookNowModalData
	            }),
	            _react2.default.createElement(
	              _ResponsiveContainer2.default,
	              null,
	              _react2.default.createElement(
	                _styledComponents.MainLayoutContainer,
	                null,
	                _react2.default.createElement(
	                  _styledComponents.HeaderContainer,
	                  null,
	                  _react2.default.createElement(
	                    _styledComponents.HeaderText,
	                    null,
	                    heading
	                  ),
	                  _react2.default.createElement(
	                    _styledComponents.CaptionText,
	                    null,
	                    caption
	                  )
	                ),
	                _react2.default.createElement(
	                  _styledComponents.ProfileContainer,
	                  null,
	                  _react2.default.createElement(_styledComponents.ProfilePic, { src: authorPicUrl }),
	                  _react2.default.createElement(
	                    _styledComponents.NameContainer,
	                    null,
	                    _react2.default.createElement(
	                      _styledComponents.NameText,
	                      null,
	                      authorName
	                    ),
	                    authorDesignation !== _themeConstants.NOT_APPLICABLE && authorDesignation && authorDesignation.trim() && _react2.default.createElement(
	                      _styledComponents.DesignationText,
	                      { as: 'p' },
	                      authorDesignation
	                    ),
	                    _react2.default.createElement(
	                      _styledComponents.StatusContainer,
	                      null,
	                      _react2.default.createElement(
	                        _styledComponents.DateText,
	                        { as: 'p' },
	                        articleFormattedDate
	                      ),
	                      _react2.default.createElement(_styledComponents.Dot, null),
	                      _react2.default.createElement(
	                        _styledComponents.ReadingTime,
	                        null,
	                        readingTime + ' read'
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _ResponsiveContainer2.default,
	              null,
	              _react2.default.createElement(
	                _styledComponents.BodyLayoutContainer,
	                null,
	                _react2.default.createElement('div', {
	                  className: 'bodyLayoutContainer',
	                  dangerouslySetInnerHTML: {
	                    __html: html
	                  }
	                }),
	                disclaimer !== _themeConstants.NOT_APPLICABLE && disclaimer && disclaimer.trim() && _react2.default.createElement(
	                  'p',
	                  { className: 'Disclaimer' },
	                  disclaimer
	                ),
	                _react2.default.createElement('br', null)
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'div',
	                { className: 'border' },
	                '\u2756 \u2756 \u2756'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null)
	            )
	          ),
	          _react2.default.createElement(_Footer2.default, _extends({}, footerProps, { theme: _darkTheme2.default.footerSection }))
	        )
	      )
	    );
	  }
	  return null;
	};
	
	exports.default = Template;
	
	// eslint-disable-next-line
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LoaderContainer = exports.NewsHeading = exports.SignatureContainer = exports.ShareAricleContainer = exports.IconWrapperContainer = exports.FooterDivider = exports.FooterLayoutContainer = exports.BodyLayoutContainer = exports.BlogHeroImage = exports.ReadingTime = exports.Dot = exports.DateText = exports.StatusContainer = exports.DesignationText = exports.NameText = exports.NameContainer = exports.ProfilePic = exports.ProfileContainer = exports.CaptionText = exports.HeaderText = exports.HeaderContainer = exports.MainLayoutContainer = exports.BlogPageContainer = undefined;
	
	var _reactEmotion = __webpack_require__(2);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Colors = __webpack_require__(3);
	
	var _Colors2 = _interopRequireDefault(_Colors);
	
	var _Din = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPageContainer = /*#__PURE__*/exports.BlogPageContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e0'
	})('font-size:1rem;');
	
	var MainLayoutContainer = /*#__PURE__*/exports.MainLayoutContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e1'
	})('margin-top:8.5em;width:43.875em;margin-left:auto;margin-right:auto;@media (min-width:320px) and (max-width:425px){width:100%;margin-top:5.625em;}@media (min-width:426px) and (max-width:767px){width:100%;}');
	var HeaderContainer = /*#__PURE__*/exports.HeaderContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e2'
	})('display:flex;flex-direction:column;margin-bottom:1.25em;justify-content:center;align-items:center;');
	
	var HeaderText = /*#__PURE__*/exports.HeaderText = (0, _reactEmotion2.default)('h1', {
	  target: 'eh9wp3e3'
	})('color:#0d1921;font-size:2.006em;text-align:center;color:', function (props) {
	  return props.theme.primaryTextColor;
	}, ';line-height:1.38;letter-spacing:normal;font-family:\'PT Serif\',serif;font-weight:bold;@media (min-width:320px) and (max-width:425px){font-size:1.714em;}');
	var CaptionText = /*#__PURE__*/exports.CaptionText = (0, _reactEmotion2.default)('p', {
	  target: 'eh9wp3e4'
	})('color:#0d1921;font-size:1em;font-weight:normal;font-family:\'PT Serif\',serif;color:', function (props) {
	  return props.theme.primaryTextColor;
	}, ';opacity:0.6;text-align:center;margin-left:3.75em;margin-right:3.75em;margin-top:0.625em;line-height:1.56;@media (min-width:320px) and (max-width:425px){font-size:1em;line-height:1.71;margin-left:auto;margin-right:auto;}');
	
	var ProfileContainer = /*#__PURE__*/exports.ProfileContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e5'
	})('display:flex;flex-direction:row;margin-bottom:1.25em;justify-content:center;');
	var ProfilePic = /*#__PURE__*/exports.ProfilePic = (0, _reactEmotion2.default)('img', {
	  target: 'eh9wp3e6'
	})('width:3.75em;height:3.75em;object-fit:cover;border-radius:100%;');
	// TODO: Need to check
	var NameContainer = /*#__PURE__*/exports.NameContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e7'
	})('display:flex;flex-direction:column;margin-left:0.625em;justify-content:center;');
	// color: ${props => props.theme.primaryTextColor};
	var NameText = /*#__PURE__*/exports.NameText = (0, _reactEmotion2.default)('p', {
	  target: 'eh9wp3e8'
	})('font-family:din-2014;font-size:0.875em;font-weight:600;text-align:left;color:#0d1921;margin-bottom:0px;margin-top:0px;line-height:1.42;');
	var DesignationText = /*#__PURE__*/exports.DesignationText = (0, _reactEmotion2.default)(_Din.BaseDin2014, {
	  target: 'eh9wp3e9'
	})('font-size:0.75em;color:', _Colors2.default.charcoalGrey, ';text-align:left;line-height:1.42;margin-bottom:0px;margin-top:0px;');
	var StatusContainer = /*#__PURE__*/exports.StatusContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e10'
	})('display:flex;width:10em;flex-direction:row;justify-content:space-between;align-items:center;');
	var DateText = /*#__PURE__*/exports.DateText = (0, _reactEmotion2.default)(_Din.BaseDin2014, {
	  target: 'eh9wp3e11'
	})('font-size:0.75em;text-align:left;color:', _Colors2.default.charcoalGrey, ';margin-bottom:0px;margin-top:0px;');
	
	var Dot = /*#__PURE__*/exports.Dot = (0, _reactEmotion2.default)('span', {
	  target: 'eh9wp3e12'
	})('background-color:', _Colors2.default.charcoalGrey, ';height:0.214em;width:0.214em;border-radius:50%;display:inline-block;');
	
	var ReadingTime = /*#__PURE__*/exports.ReadingTime = (0, _reactEmotion2.default)('p', {
	  target: 'eh9wp3e13'
	})('font-family:din-2014;font-size:0.75em;text-align:left;color:', _Colors2.default.charcoalGrey, ';margin-bottom:0px;margin-top:0px;');
	
	var BlogHeroImage = /*#__PURE__*/exports.BlogHeroImage = (0, _reactEmotion2.default)('img', {
	  target: 'eh9wp3e14'
	})('height:31.25em;width:100%;object-fit:contain;@media (min-width:320px) and (max-width:425px){height:8.929em;}@media (min-width:426px) and (max-width:767px){height:7.813em;}');
	
	var BodyLayoutContainer = /*#__PURE__*/exports.BodyLayoutContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e15'
	})('margin-top:3.75em;width:43.875em;@media (min-width:320px) and (max-width:425px){width:100%;margin-top:1.25em;}@media (min-width:426px) and (max-width:767px){width:100%;margin-top:1.25em;}margin-left:auto;margin-right:auto;');
	var FooterLayoutContainer = /*#__PURE__*/exports.FooterLayoutContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e16'
	})('margin-top:6.25em;width:43.875em;@media (min-width:320px) and (max-width:425px){width:100%;margin-top:3.75em;}@media (min-width:426px) and (max-width:767px){width:100%;margin-top:3.75em;}margin-left:auto;margin-right:auto;');
	var FooterDivider = /*#__PURE__*/exports.FooterDivider = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e17'
	})('width:100%;border:1px solid;color:#d7e3f3;');
	var IconWrapperContainer = /*#__PURE__*/exports.IconWrapperContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e18'
	})('display:flex;flex-direction:row;max-width:15.625em;height:2.25em;justify-content:space-around;margin-bottom:1.25em;margin-left:auto;margin-right:auto;');
	
	var ShareAricleContainer = /*#__PURE__*/exports.ShareAricleContainer = (0, _reactEmotion2.default)('span', {
	  target: 'eh9wp3e19'
	})('display:flex;justify-content:center;align-items:center;margin-top:1.25em;margin-bottom:0.625em;');
	
	var SignatureContainer = /*#__PURE__*/exports.SignatureContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e20'
	})('margin-top:2.5em;margin-bottom:2.5em;');
	
	var NewsHeading = /*#__PURE__*/exports.NewsHeading = (0, _reactEmotion2.default)('h1', {
	  target: 'eh9wp3e21'
	})('font-weight:600;font-size:28px;');
	
	var LoaderContainer = /*#__PURE__*/exports.LoaderContainer = (0, _reactEmotion2.default)('div', {
	  target: 'eh9wp3e22'
	})('height:70vh;background:#000000;display:flex;justify-content:center;align-items:center;');

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getArticleFormattedDateTime = undefined;
	
	var _format = __webpack_require__(248);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getArticleFormattedDateTime = exports.getArticleFormattedDateTime = function getArticleFormattedDateTime(date) {
	  var outputformat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMM DD, YYYY';
	
	  var readableDate = date;
	  if (!date) return null;
	  try {
	    readableDate = (0, _format2.default)(date, outputformat);
	  } catch (error) {}
	  return readableDate;
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-template-js-9471c5ca5636d408de51.js